import React from 'react';
import STCIcon from 'src/components/10-atoms/icons/STCIcon';
import { createTabScreen } from 'src/navigation/primaryNav/createTabScreen';
import { RootTab } from 'src/navigation/TabNavigation';
import withSuspense from 'src/navigation/withSuspense';
const Home = withSuspense(React.lazy(() => import('./screens/Home')));
export const stcNavEntry = {
    id: 'stc',
    prefix: 'STC_',
    to: { screen: 'STC_Home', params: {} },
    label: ({ translate }) => translate('Support Us'),
    renderIcon: (color, size) => React.createElement(STCIcon, { color: color, size: size }),
    isVisible: () => true,
    placements: ['tab', 'sidebar-footer'],
    renderTabRoutes(ctx) {
        return (React.createElement(RootTab.Group, null, createTabScreen(stcNavEntry, ctx, 'STC_Home', Home)));
    },
};
export function renderSTCTabRoutes(ctx) {
    return stcNavEntry.renderTabRoutes(ctx);
}
